import React, { useState } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  TextField,
  Grid,
  TableHead,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import NumberFormat from 'react-number-format';
import { useStateValue } from '../../contexto/store';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import moment from 'moment';
import {
  obtenerFacturasBajaNotificacion,
  realizarPago,
} from '../../actions/CobranzasAction.js';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 600,
  },
}));
function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator="."
      decimalSeparator={false}
      isNumericString
    />
  );
}
const columns = [
  { id: 'nrocomprobante', label: 'Nro Factura', minWidth: 100 },
  { id: 'cliente', label: 'Cliente', minWidth: 200 },
  { id: 'fechacomprobante', label: 'Fec.Comprobante', minWidth: 100 },
  { id: 'fechavencimiento', label: 'Fec.Vto', minWidth: 100 },
  { id: 'totalfactura', label: 'Total Comprobante', minWidth: 100 },
  { id: 'montopagado', label: 'Monto Pagado', minWidth: 100 },
  { id: 'saldoapagar', label: 'Saldo a pagar', minWidth: 100 },
  { id: 'importe', label: 'Importe', minWidth: 100 },
];
export default function TBajaFacturas(props) {
  const classes = useStyles();
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDialog, setOpenDialog] = useState(false);
  const hayElementosConImporteMayor = (factura) =>
    parseInt(factura.importe) > factura.totalfactura - factura.montopagado;
  const sinImportes = (factura) =>
    factura.importe === 0 || factura.importe === '' || !factura.importe;
  const AddImporte = (e) => {
    props.setRows(
      props.rows.map((item) =>
        item.id === e.target.name ? { ...item, importe: e.target.value } : item
      )
    );
  };
  const abrirDialog = () => {
    setOpenDialog(true);
  };
  const cerrarDialog = () => {
    setOpenDialog(false);
  };
  const CargarPagos = () => {
    if (props.rows.every(sinImportes)) {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Debe cargar al menos un pago para continuar',
        },
      });
    } else {
      props.rows.map((factura) => {
        if (
          factura.importe !== '' &&
          factura.importe !== 0 &&
          factura.importe < factura.totalfactura - factura.montopagado
        ) {
          let objetoPagoParcial = {
            importe: parseInt(factura.importe),
            estado: 'COB',
          };
          realizarPago(factura.id, objetoPagoParcial).then((response) => {
            if (response.status !== 200) {
              console.log('ERROR AL INTENTAR PAGAR UNA FACTURA ');
            } else {
              if (props.cliente !== undefined) {
                props.setCliente({
                  nombre: props.cliente.nombre,
                  apellido: props.cliente.apellido,
                  clientE_Id: props.cliente.clientE_Id,
                });
              } else {
                let objetoNoti = {
                  USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
                  UserName: sesionUsuario.usuario.userName,
                };
                obtenerFacturasBajaNotificacion(objetoNoti);
                window.location.reload();
              }
            }
          });
        } else if (
          factura.importe !== '' &&
          factura.importe !== 0 &&
          parseInt(factura.importe) ===
            factura.totalfactura - factura.montopagado
        ) {
          let objetoPagoTotal = {
            importe: parseInt(factura.importe),
            cerradocobrado: moment().format(),
            estado: 'COB',
          };
          realizarPago(factura.id, objetoPagoTotal).then((response) => {
            if (response.status !== 200) {
              console.log('ERROR AL INTENTAR PAGAR UNA FACTURA');
            } else {
              if (props.cliente !== undefined) {
                props.setCliente({
                  nombre: props.cliente.nombre,
                  apellido: props.cliente.apellido,
                  clientE_Id: props.cliente.clientE_Id,
                });
              } else {
                let objetoNoti = {
                  USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
                  UserName: sesionUsuario.usuario.userName,
                };
                obtenerFacturasBajaNotificacion(objetoNoti);
                window.location.reload();
              }
            }
          });
        }
        return null;
      });
    }
    cerrarDialog();
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Paper className={classes.root}>
      <Grid container direction="row" justify="flex-end" alignItems="center">
        <Button
          disabled={props.rows.some(hayElementosConImporteMayor)}
          size="large"
          variant="contained"
          color="primary"
          startIcon={<LocalAtmIcon style={{ fontSize: 40 }} />}
          onClick={abrirDialog}
        >
          Cargar Pagos
        </Button>
      </Grid>
      <br />
      <TableContainer className={classes.container}>
        <Table size="small" stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((factura, index) => (
                <TableRow key={factura.id}>
                  {/*RRR: se verifica la forma en que se reciben los datos por que se puede dar que viene de
                      entity o de una vista*/}
                  <TableCell align="left">{factura.nrocomprobante}</TableCell>
                  <TableCell align="left">
                    {factura.cliente.nombre + ' ' + factura.cliente.apellido}
                  </TableCell>
                  <TableCell align="left">
                    {moment(factura.fechacomprobante).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell align="left">
                    {moment(factura.fechavencimiento).format() <
                    moment().format() ? (
                      <Typography style={{ color: '#b2102f' }}>
                        {moment(factura.fechavencimiento).format('DD/MM/YYYY')}
                      </Typography>
                    ) : (
                      <Typography style={{ color: '#357a38' }}>
                        {moment(factura.fechavencimiento).format('DD/MM/YYYY')}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {Intl.NumberFormat('es').format(factura.totalfactura)}
                  </TableCell>
                  <TableCell align="left">
                    {Intl.NumberFormat('es').format(factura.montopagado)}
                  </TableCell>
                  <TableCell align="left">
                    {Intl.NumberFormat('es').format(
                      factura.totalfactura - factura.montopagado
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {parseInt(factura.importe) >
                    factura.totalfactura - factura.montopagado ? (
                      <TextField
                        error
                        color="secondary"
                        label="Mayor"
                        fullWidth
                        name={factura.id}
                        value={factura.importe}
                        onChange={AddImporte}
                        variant="outlined"
                        size="small"
                        InputProps={{
                          inputComponent: NumberFormatCustom,
                        }}
                      ></TextField>
                    ) : (
                      <TextField
                        fullWidth
                        name={factura.id}
                        value={factura.importe}
                        onChange={AddImporte}
                        variant="outlined"
                        size="small"
                        InputProps={{
                          inputComponent: NumberFormatCustom,
                        }}
                      ></TextField>
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={props.rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <div notranslate="true">
        <Dialog
          open={openDialog}
          onClose={cerrarDialog}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Alerta</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Estas seguro de Cargar los Pagos?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={cerrarDialog}
              variant="contained"
              color="secondary"
            >
              Cancelar
            </Button>
            <Button variant="contained" onClick={CargarPagos} color="primary">
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Paper>
  );
}
